import React, {useEffect, useState} from "react"
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService"

const WHITE = "#FFFFFF"

const CARD_POSITIONS = [
    {left: "12%",   right: "71.5%"},
    {left: "32%",   right: "52%"},
    {left: "51.5%", right: "31.5%"},
    {left: "71.5%", right: "12%"}
]

export default function ScreenDonSection({context, campagneData}) {
    const [loading, setLoading] = useState(true)
    const [dons, setDons] = useState([])

    const formater = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2})
    const partnerMontant = campagneData?.partnerMontant || 1
    const screenOptions = campagneData?.screenOptions || {}

    const getDisplayName = (campagneExtraData = {}) => {
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons = async () => {
        const url = "/campagne/donors/" + campagneData.id
        const res = await ApiService.get(url)
        let _dons = res.data
        if (screenOptions.minMontant) {
            _dons = _dons.filter(i => i.montant >= screenOptions.minMontant)
        }
        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)

    if (loading) {
        return null
    }

    const visibleDons = dons.slice(0, 4)

    return (
        <>
            {visibleDons.map((d, index) => {
                const pos = CARD_POSITIONS[index]
                if (!pos) return null

                const nbUnits = d.montant / partnerMontant
                const unitLabel = nbUnits > 1 ? "Enfants" : "Enfant"

                return (
                    <div
                        key={d.id}
                        className="screen-don-card screenDonFadeIn"
                        style={{
                            position: "absolute",
                            top: "53%",
                            bottom: "33%",
                            left: pos.left,
                            right: pos.right,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            color: WHITE,
                            textAlign: "center",
                            gap: "0vh",
                            height:"16vh"
                        }}
                    >
                        <div style={{
                            fontFamily: "ProximaNovaRouan, sans-serif",
                            fontWeight: 900,
                            fontSize: "2.8vh",
                            letterSpacing: "1px",
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "100%"
                        }}>
                            {getDisplayName(d.campagneExtraData)}
                        </div>

                        <div style={{
                            fontFamily: "ProximaNovaRouan, sans-serif",
                            fontStyle: "italic",
                            fontWeight:400,
                            fontSize: "4vh",
                            textDecorationLine:"underline"
                        }}>
                            {`${formater.format(nbUnits)} ${unitLabel}`}
                        </div>
                    </div>
                )
            })}
        </>
    )
}
